import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { TableExt, TableInfo, GridBox, GridColumnsSetup } from 'libs/ui';
import { useGridColumns } from 'libs/hooks';
import { getTableParams } from './grid.params';

export const CallsGrid = (props) => {
  const { count, entries, className, theme, getXlsAction } = props;
  const { t } = useTranslation();

  // items
  const items = Object.keys(entries).map((key) => entries[key]);

  // actions
  const actions = [];

  // top actions
  const topActions = [];
  if (count) {
    getXlsAction(topActions);
  }

  const tableParams = useMemo(() => getTableParams(t), []);
  const { getFields, fields: staticFields, ...restTableParams } = tableParams;
  const defaultFields = useMemo(() => (getFields ? getFields(props) : staticFields), [getFields, staticFields, props]);
  const { fields, columns, toggleColumn, reorderColumns, resetColumns } = useGridColumns('calls', defaultFields);
  topActions.push({ cmp: <GridColumnsSetup key="columns-setup" columns={columns} onToggle={toggleColumn} onReorder={reorderColumns} onReset={resetColumns} /> });

  return (
    <GridBox>
      <TableInfo theme={theme} count={count} actions={topActions} />

      <TableExt theme={theme} title={t('sections.Звонки')} rows={{ count, items }} actions={actions} className={className} refresh={props.refresh} {...restTableParams} fields={fields} />
    </GridBox>
  );
};
